module.exports = __webpack_public_path__ + "img/interestFollowUps.a2a38522.svg";